import { StudentRegistrationTypes } from '../enums';

export const TypeOfOwnerData = [
  {
    name: {
      en: 'Institution or Company',
      ar: 'مؤسسة أو شركة'
    },
    id: 'InstitutionOrCompany'
  },
  {
    name: {
      en: 'Individual',
      ar: 'فرد'
    },
    id: 'Individual'
  }
];

export const Nationalities = [
  { name: { en: 'Afghan', ar: 'أفغاني' }, id: 'afghan' },
  { name: { en: 'Albanian', ar: 'ألباني' }, id: 'albanian' },
  { name: { en: 'Algerian', ar: 'جزائري' }, id: 'algerian' },
  { name: { en: 'American', ar: 'أمريكي' }, id: 'american' },
  { name: { en: 'Andorran', ar: 'أندوري' }, id: 'andorran' },
  { name: { en: 'Angolan', ar: 'أنغولي' }, id: 'angolan' },
  { name: { en: 'Anguillan', ar: 'أنغويلا' }, id: 'anguillan' },
  { name: { en: 'Argentine', ar: 'أرجنتيني' }, id: 'argentine' },
  { name: { en: 'Armenian', ar: 'أرميني' }, id: 'armenian' },
  { name: { en: 'Australian', ar: 'أسترالي' }, id: 'australian' },
  { name: { en: 'Austrian', ar: 'نمساوي' }, id: 'austrian' },
  { name: { en: 'Azerbaijani', ar: 'أذربيجاني' }, id: 'azerbaijani' },
  { name: { en: 'Bahamian', ar: 'باهامي' }, id: 'bahamian' },
  { name: { en: 'Bahraini', ar: 'بحريني' }, id: 'bahraini' },
  { name: { en: 'Bangladeshi', ar: 'بنغلاديشي' }, id: 'bangladeshi' },
  { name: { en: 'Barbadian', ar: 'بربادوسي' }, id: 'barbadian' },
  { name: { en: 'Belarusian', ar: 'بيلاروسي' }, id: 'belarusian' },
  { name: { en: 'Belgian', ar: 'بلجيكي' }, id: 'belgian' },
  { name: { en: 'Belizean', ar: 'بليزي' }, id: 'belizean' },
  { name: { en: 'Beninese', ar: 'بنيني' }, id: 'beninese' },
  { name: { en: 'Bermudian', ar: 'برمودي' }, id: 'bermudian' },
  { name: { en: 'Bhutanese', ar: 'بوتاني' }, id: 'bhutanese' },
  { name: { en: 'Bolivian', ar: 'بوليفي' }, id: 'bolivian' },
  { name: { en: 'Botswanan', ar: 'بتسواني' }, id: 'botswanan' },
  { name: { en: 'Brazilian', ar: 'برازيلي' }, id: 'brazilian' },
  { name: { en: 'British', ar: 'بريطاني' }, id: 'british' },
  {
    name: { en: 'British Virgin Islander', ar: 'بريطاني جزر العذراء' },
    id: 'british virgin islander'
  },
  { name: { en: 'Bruneian', ar: 'بروناي' }, id: 'bruneian' },
  { name: { en: 'Bulgarian', ar: 'بلغاري' }, id: 'bulgarian' },
  { name: { en: 'Burkinan', ar: 'بوركيني' }, id: 'burkinan' },
  { name: { en: 'Burmese', ar: 'بورمي' }, id: 'burmese' },
  { name: { en: 'Burundian', ar: 'بوروندي' }, id: 'burundian' },
  { name: { en: 'Cambodian', ar: 'كمبودي' }, id: 'cambodian' },
  { name: { en: 'Cameroonian', ar: 'كاميروني' }, id: 'cameroonian' },
  { name: { en: 'Canadian', ar: 'كندي' }, id: 'canadian' },
  { name: { en: 'Cape Verdean', ar: 'الرأس الأخضر' }, id: 'cape verdean' },
  { name: { en: 'Cayman Islander', ar: 'كايماني' }, id: 'cayman islander' },
  { name: { en: 'Central African', ar: 'وسط أفريقي' }, id: 'central african' },
  { name: { en: 'Chadian', ar: 'تشادي' }, id: 'chadian' },
  { name: { en: 'Chilean', ar: 'تشيلي' }, id: 'chilean' },
  { name: { en: 'Chinese', ar: 'صيني' }, id: 'chinese' },
  {
    name: { en: 'Citizen of Antigua and Barbuda', ar: 'مواطن أنتيغوا وبربودا' },
    id: 'citizen of antigua and barbuda'
  },
  {
    name: {
      en: 'Citizen of Bosnia and Herzegovina',
      ar: 'مواطن البوسنة والهرسك'
    },
    id: 'citizen of bosnia and herzegovina'
  },
  {
    name: { en: 'Citizen of Guinea-Bissau', ar: 'مواطن غينيا بيساو' },
    id: 'citizen of guinea bissau'
  },
  {
    name: { en: 'Citizen of Kiribati', ar: 'مواطن كيريباتي' },
    id: 'citizen of kiribati'
  },
  {
    name: { en: 'Citizen of Seychelles', ar: 'مواطن سيشيلي' },
    id: 'citizen of seychelles'
  },
  {
    name: {
      en: 'Citizen of the Dominican Republic',
      ar: 'مواطن الجمهورية الدومينيكية'
    },
    id: 'citizen of the dominican republic'
  },
  {
    name: { en: 'Citizen of Vanuatu', ar: 'مواطن فانواتو' },
    id: 'citizen of vanuatu'
  },
  { name: { en: 'Colombian', ar: 'كولومبي' }, id: 'colombian' },
  { name: { en: 'Comoran', ar: 'جزر القمر' }, id: 'comoran' },
  {
    name: { en: 'Congolese (Congo)', ar: 'كونغولي (الكونغو)' },
    id: 'congolese congo'
  },
  {
    name: {
      en: 'Congolese (DRC)',
      ar: 'كونغولي (جمهورية الكونغو الديمقراطية)'
    },
    id: 'congolese drc'
  },
  { name: { en: 'Cook Islander', ar: 'جزر كوك' }, id: 'cook islander' },
  { name: { en: 'Costa Rican', ar: 'كوستاريكي' }, id: 'costa rican' },
  { name: { en: 'Croatian', ar: 'كرواتي' }, id: 'croatian' },
  { name: { en: 'Cuban', ar: 'كوبي' }, id: 'cuban' },
  { name: { en: 'Cymraes', ar: 'ويلزية' }, id: 'cymraes' },
  { name: { en: 'Cymro', ar: 'ويلزي' }, id: 'cymro' },
  { name: { en: 'Cypriot', ar: 'قبرصي' }, id: 'cypriot' },
  { name: { en: 'Czech', ar: 'تشيكي' }, id: 'czech' },
  { name: { en: 'Danish', ar: 'دانماركي' }, id: 'danish' },
  { name: { en: 'Djiboutian', ar: 'جيبوتي' }, id: 'djiboutian' },
  { name: { en: 'Dominican', ar: 'دومينيكي' }, id: 'dominican' },
  { name: { en: 'Dutch', ar: 'هولندي' }, id: 'dutch' },
  { name: { en: 'East Timorese', ar: 'تيموري' }, id: 'east timorese' },
  { name: { en: 'Ecuadorean', ar: 'إكوادوري' }, id: 'ecuadorean' },
  { name: { en: 'Egyptian', ar: 'مصري' }, id: 'egyptian' },
  { name: { en: 'Emirati', ar: 'إماراتي' }, id: 'emirati' },
  { name: { en: 'English', ar: 'إنجليزي' }, id: 'english' },
  {
    name: { en: 'Equatorial Guinean', ar: 'غينيا الإستوائية' },
    id: 'equatorial guinean'
  },
  { name: { en: 'Eritrean', ar: 'إريتري' }, id: 'eritrean' },
  { name: { en: 'Estonian', ar: 'إستوني' }, id: 'estonian' },
  { name: { en: 'Ethiopian', ar: 'إثيوبي' }, id: 'ethiopian' },
  { name: { en: 'Faroese', ar: 'فاروي' }, id: 'faroese' },
  { name: { en: 'Fijian', ar: 'فيجي' }, id: 'fijian' },
  { name: { en: 'Filipino', ar: 'فلبيني' }, id: 'filipino' },
  { name: { en: 'Finnish', ar: 'فنلندي' }, id: 'finnish' },
  { name: { en: 'French', ar: 'فرنسي' }, id: 'french' },
  { name: { en: 'Gabonese', ar: 'غابوني' }, id: 'gabonese' },
  { name: { en: 'Gambian', ar: 'غامبي' }, id: 'gambian' },
  { name: { en: 'Georgian', ar: 'جورجي' }, id: 'georgian' },
  { name: { en: 'German', ar: 'ألماني' }, id: 'german' },
  { name: { en: 'Ghanaian', ar: 'غاني' }, id: 'ghanaian' },
  { name: { en: 'Gibraltarian', ar: 'جبل طارقي' }, id: 'gibraltarian' },
  { name: { en: 'Greek', ar: 'يوناني' }, id: 'greek' },
  { name: { en: 'Greenlandic', ar: 'جرينلاندي' }, id: 'greenlandic' },
  { name: { en: 'Grenadian', ar: 'غريناداوي' }, id: 'grenadian' },
  { name: { en: 'Guamanian', ar: 'جوامي' }, id: 'guamanian' },
  { name: { en: 'Guatemalan', ar: 'جواتيمالي' }, id: 'guatemalan' },
  { name: { en: 'Guinean', ar: 'غيني' }, id: 'guinean' },
  { name: { en: 'Guyanese', ar: 'غياني' }, id: 'guyanese' },
  { name: { en: 'Haitian', ar: 'هايتي' }, id: 'haitian' },
  { name: { en: 'Honduran', ar: 'هنديوراسي' }, id: 'honduran' },
  { name: { en: 'Hong Konger', ar: 'هونغ كونغي' }, id: 'hong konger' },
  { name: { en: 'Hungarian', ar: 'هنغاري' }, id: 'hungarian' },
  { name: { en: 'Icelandic', ar: 'آيسلندي' }, id: 'icelandic' },
  { name: { en: 'Indian', ar: 'هندي' }, id: 'indian' },
  { name: { en: 'Indonesian', ar: 'إندونيسي' }, id: 'indonesian' },
  { name: { en: 'Iranian', ar: 'إيراني' }, id: 'iranian' },
  { name: { en: 'Iraqi', ar: 'عراقي' }, id: 'iraqi' },
  { name: { en: 'Irish', ar: 'إيرلندي' }, id: 'irish' },
  { name: { en: 'Israeli', ar: 'إسرائيلي' }, id: 'israeli' },
  { name: { en: 'Italian', ar: 'إيطالي' }, id: 'italian' },
  { name: { en: 'Ivorian', ar: 'إيفواري' }, id: 'ivorian' },
  { name: { en: 'Jamaican', ar: 'جامايكي' }, id: 'jamaican' },
  { name: { en: 'Japanese', ar: 'ياباني' }, id: 'japanese' },
  { name: { en: 'Jordanian', ar: 'أردني' }, id: 'jordanian' },
  { name: { en: 'Kazakh', ar: 'كازاخي' }, id: 'kazakh' },
  { name: { en: 'Kenyan', ar: 'كيني' }, id: 'kenyan' },
  { name: { en: 'Kittitian', ar: 'كيتيسي ونيفيسي' }, id: 'kittitian' },
  { name: { en: 'Kosovan', ar: 'كوسوفي' }, id: 'kosovan' },
  { name: { en: 'Kuwaiti', ar: 'كويتي' }, id: 'kuwaiti' },
  { name: { en: 'Kyrgyz', ar: 'قرغيزي' }, id: 'kyrgyz' },
  { name: { en: 'Lao', ar: 'لاوي' }, id: 'lao' },
  { name: { en: 'Latvian', ar: 'لاتفي' }, id: 'latvian' },
  { name: { en: 'Lebanese', ar: 'لبناني' }, id: 'lebanese' },
  { name: { en: 'Liberian', ar: 'ليبيري' }, id: 'liberian' },
  { name: { en: 'Libyan', ar: 'ليبي' }, id: 'libyan' },
  {
    name: { en: 'Liechtenstein citizen', ar: 'ليختنشتايني' },
    id: 'liechtenstein citizen'
  },
  { name: { en: 'Lithuanian', ar: 'ليتواني' }, id: 'lithuanian' },
  { name: { en: 'Luxembourger', ar: 'لوكسمبرجي' }, id: 'luxembourger' },
  { name: { en: 'Macanese', ar: 'ماكاوي' }, id: 'macanese' },
  { name: { en: 'Macedonian', ar: 'مقدوني' }, id: 'macedonian' },
  { name: { en: 'Malagasy', ar: 'مدغشقري' }, id: 'malagasy' },
  { name: { en: 'Malawian', ar: 'مالاوي' }, id: 'malawian' },
  { name: { en: 'Malaysian', ar: 'ماليزي' }, id: 'malaysian' },
  { name: { en: 'Maldivian', ar: 'مالديفي' }, id: 'maldivian' },
  { name: { en: 'Malian', ar: 'مالي' }, id: 'malian' },
  { name: { en: 'Maltese', ar: 'مالطي' }, id: 'maltese' },
  { name: { en: 'Marshallese', ar: 'جزر المارشال' }, id: 'marshallese' },
  { name: { en: 'Martiniquais', ar: 'مارتينيكي' }, id: 'martiniquais' },
  { name: { en: 'Mauritanian', ar: 'موريتاني' }, id: 'mauritanian' },
  { name: { en: 'Mauritian', ar: 'موريشيوسي' }, id: 'mauritian' },
  { name: { en: 'Mexican', ar: 'مكسيكي' }, id: 'mexican' },
  { name: { en: 'Micronesian', ar: 'ميكرونيزي' }, id: 'micronesian' },
  { name: { en: 'Moldovan', ar: 'مولدوفي' }, id: 'moldovan' },
  { name: { en: 'Monegasque', ar: 'موناكي' }, id: 'monegasque' },
  { name: { en: 'Mongolian', ar: 'منغولي' }, id: 'mongolian' },
  { name: { en: 'Montenegrin', ar: 'مونتينيغري' }, id: 'montenegrin' },
  { name: { en: 'Montserratian', ar: 'مونتسراتي' }, id: 'montserratian' },
  { name: { en: 'Moroccan', ar: 'مغربي' }, id: 'moroccan' },
  { name: { en: 'Mosotho', ar: 'ليسوتي' }, id: 'mosotho' },
  { name: { en: 'Mozambican', ar: 'موزمبيقي' }, id: 'mozambican' },
  { name: { en: 'Namibian', ar: 'ناميبي' }, id: 'namibian' },
  { name: { en: 'Nauruan', ar: 'ناورو' }, id: 'nauruan' },
  { name: { en: 'Nepalese', ar: 'نيبالي' }, id: 'nepalese' },
  { name: { en: 'New Zealander', ar: 'نيوزيلندي' }, id: 'new zealander' },
  { name: { en: 'Nicaraguan', ar: 'نيكاراغوي' }, id: 'nicaraguan' },
  { name: { en: 'Nigerian', ar: 'نيجيري' }, id: 'nigerian' },
  { name: { en: 'Nigerien', ar: 'نيجري' }, id: 'nigerien' },
  { name: { en: 'Niuean', ar: 'نيوي' }, id: 'niuean' },
  { name: { en: 'North Korean', ar: 'كوري شمالي' }, id: 'north korean' },
  { name: { en: 'Northern Irish', ar: 'أيرلندي شمالي' }, id: 'northern irish' },
  { name: { en: 'Norwegian', ar: 'نرويجي' }, id: 'norwegian' },
  { name: { en: 'Omani', ar: 'عماني' }, id: 'omani' },
  { name: { en: 'Pakistani', ar: 'باكستاني' }, id: 'pakistani' },
  { name: { en: 'Palauan', ar: 'بالاوي' }, id: 'palauan' },
  { name: { en: 'Palestinian', ar: 'فلسطيني' }, id: 'palestinian' },
  { name: { en: 'Panamanian', ar: 'بنمي' }, id: 'panamanian' },
  {
    name: { en: 'Papua New Guinean', ar: 'بابوا غينيا الجديدة' },
    id: 'papua new guinean'
  },
  { name: { en: 'Paraguayan', ar: 'باراغواياني' }, id: 'paraguayan' },
  { name: { en: 'Peruvian', ar: 'بيرو' }, id: 'peruvian' },
  {
    name: { en: 'Pitcairn Islander', ar: 'جزيرة بيتكيرن' },
    id: 'pitcairn islander'
  },
  { name: { en: 'Polish', ar: 'بولندي' }, id: 'polish' },
  { name: { en: 'Portuguese', ar: 'برتغالي' }, id: 'portuguese' },
  { name: { en: 'Prydeinig', ar: 'بريطاني' }, id: 'prydeinig' },
  { name: { en: 'Puerto Rican', ar: 'بورتوريكي' }, id: 'puerto rican' },
  { name: { en: 'Qatari', ar: 'قطري' }, id: 'qatari' },
  { name: { en: 'Romanian', ar: 'روماني' }, id: 'romanian' },
  { name: { en: 'Russian', ar: 'روسي' }, id: 'russian' },
  { name: { en: 'Rwandan', ar: 'رواندي' }, id: 'rwandan' },
  { name: { en: 'Salvadorean', ar: 'سلفادوري' }, id: 'salvadorean' },
  { name: { en: 'Sammarinese', ar: 'سامارينيز' }, id: 'sammarinese' },
  { name: { en: 'Samoan', ar: 'ساموي' }, id: 'samoan' },
  { name: { en: 'Sao Tomean', ar: 'ساو تومي وبرينسيبي' }, id: 'sao tomean' },
  { name: { en: 'Saudi Arabian', ar: 'سعودي' }, id: 'saudi arabian' },
  { name: { en: 'Scottish', ar: 'اسكتلندي' }, id: 'scottish' },
  { name: { en: 'Senegalese', ar: 'سنغالي' }, id: 'senegalese' },
  { name: { en: 'Serbian', ar: 'صربي' }, id: 'serbian' },
  { name: { en: 'Sierra Leonean', ar: 'سيراليوني' }, id: 'sierra leonean' },
  { name: { en: 'Singaporean', ar: 'سنغافوري' }, id: 'singaporean' },
  { name: { en: 'Slovak', ar: 'سلوفاكي' }, id: 'slovak' },
  { name: { en: 'Slovenian', ar: 'سلوفيني' }, id: 'slovenian' },
  {
    name: { en: 'Solomon Islander', ar: 'جزر سليمان' },
    id: 'solomon islander'
  },
  { name: { en: 'Somali', ar: 'صومالي' }, id: 'somali' },
  { name: { en: 'South African', ar: 'جنوب أفريقي' }, id: 'south african' },
  { name: { en: 'South Korean', ar: 'كوري جنوبي' }, id: 'south korean' },
  { name: { en: 'South Sudanese', ar: 'جنوب السودان' }, id: 'south sudanese' },
  { name: { en: 'Spanish', ar: 'إسباني' }, id: 'spanish' },
  { name: { en: 'Sri Lankan', ar: 'سريلانكي' }, id: 'sri lankan' },
  { name: { en: 'St Helenian', ar: 'سانت هيلينيان' }, id: 'st helenian' },
  { name: { en: 'St Lucian', ar: 'سانت لوسيان' }, id: 'st lucian' },
  { name: { en: 'Stateless', ar: 'لاجئ' }, id: 'stateless' },
  { name: { en: 'Sudanese', ar: 'سوداني' }, id: 'sudanese' },
  { name: { en: 'Surinamese', ar: 'سورينامي' }, id: 'surinamese' },
  { name: { en: 'Swazi', ar: 'سوازيلندي' }, id: 'swazi' },
  { name: { en: 'Swedish', ar: 'سويدي' }, id: 'swedish' },
  { name: { en: 'Swiss', ar: 'سويسري' }, id: 'swiss' },
  { name: { en: 'Syrian', ar: 'سوري' }, id: 'syrian' },
  { name: { en: 'Taiwanese', ar: 'تايواني' }, id: 'taiwanese' },
  { name: { en: 'Tajik', ar: 'طاجيكي' }, id: 'tajik' },
  { name: { en: 'Tanzanian', ar: 'تنزاني' }, id: 'tanzanian' },
  { name: { en: 'Thai', ar: 'تايلاندي' }, id: 'thai' },
  { name: { en: 'Togolese', ar: 'توغولي' }, id: 'togolese' },
  { name: { en: 'Tongan', ar: 'تونغي' }, id: 'tongan' },
  { name: { en: 'Trinidadian', ar: 'ترينيدادي' }, id: 'trinidadian' },
  { name: { en: 'Tristanian', ar: 'تريستاني' }, id: 'tristanian' },
  { name: { en: 'Tunisian', ar: 'تونسي' }, id: 'tunisian' },
  { name: { en: 'Turkish', ar: 'تركي' }, id: 'turkish' },
  { name: { en: 'Turkmen', ar: 'تركماني' }, id: 'turkmen' },
  {
    name: { en: 'Turks and Caicos Islander', ar: 'جزر تركس وكايكوس' },
    id: 'turks and caicos islander'
  },
  { name: { en: 'Tuvaluan', ar: 'توفالوي' }, id: 'tuvaluan' },
  { name: { en: 'Ugandan', ar: 'أوغندي' }, id: 'ugandan' },
  { name: { en: 'Ukrainian', ar: 'أوكراني' }, id: 'ukrainian' },
  { name: { en: 'Uruguayan', ar: 'أوروغواياني' }, id: 'uruguayan' },
  { name: { en: 'Uzbek', ar: 'أوزبكي' }, id: 'uzbek' },
  { name: { en: 'Vatican citizen', ar: 'فاتيكاني' }, id: 'vatican citizen' },
  { name: { en: 'Venezuelan', ar: 'فنزويلي' }, id: 'venezuelan' },
  { name: { en: 'Vietnamese', ar: 'فيتنامي' }, id: 'vietnamese' },
  { name: { en: 'Vincentian', ar: 'سانت فنسنت' }, id: 'vincentian' },
  { name: { en: 'Wallisian', ar: 'جزر واليس وفوتونا' }, id: 'wallisian' },
  { name: { en: 'Welsh', ar: 'ويلزي' }, id: 'welsh' },
  { name: { en: 'Yemeni', ar: 'يمني' }, id: 'yemeni' },
  { name: { en: 'Zambian', ar: 'زامبي' }, id: 'zambian' },
  { name: { en: 'Zimbabwean', ar: 'زيمبابوي' }, id: 'zimbabwean' }
];

export const Religiones = [
  {
    name: { en: 'Without Religion', ar: 'بدون ديانة' },
    id: 'without religion'
  },
  { name: { en: "Baha'i", ar: 'بهائي' }, id: 'bahai' },
  { name: { en: 'Buddhist', ar: 'بوذي' }, id: 'buddhist' },
  { name: { en: 'Sikhism', ar: 'سيخ' }, id: 'sikh' },
  { name: { en: 'Qadiani', ar: 'قادياني' }, id: 'qadiani' },
  { name: { en: 'Muslim', ar: 'مسلم' }, id: 'muslim' },
  { name: { en: 'Christian', ar: 'مسيحي' }, id: 'christian' },
  { name: { en: 'Hindu', ar: 'هندوسي' }, id: 'hindu' },
  { name: { en: 'Jewish', ar: 'يهودي' }, id: 'jewish' }
];

export const MaritalStatus = [
  { name: { en: 'Single', ar: 'اعزب' }, id: 'single' },
  { name: { en: 'Married', ar: 'متزوج' }, id: 'married' }
];

export const Doctrines = [
  {
    name: { en: 'Muslim - Ibadi', ar: 'مسلم - اباضي' },
    id: 'muslim ibadi',
    related: 'muslim'
  },
  {
    name: { en: "Muslim - Ja'fari", ar: 'مسلم - جعفري' },
    id: 'muslim jafari',
    related: 'muslim'
  },
  {
    name: { en: 'Muslim - Druze', ar: 'مسلم - درزي' },
    id: 'muslim druze',
    related: 'muslim'
  },
  {
    name: { en: 'Muslim - Sunni', ar: 'مسلم - سني' },
    id: 'muslim sunni',
    related: 'muslim'
  },
  {
    name: { en: 'Muslim - Shia', ar: 'مسلم - شيعي' },
    id: 'muslim shia',
    related: 'muslim'
  },
  {
    name: { en: 'Muslim - Sufi', ar: 'مسلم - صوفي' },
    id: 'muslim sufi',
    related: 'muslim'
  },
  {
    name: { en: 'Muslim - Alawi', ar: 'مسلم - علوي' },
    id: 'muslim alawi',
    related: 'muslim'
  }
];

export const Qualifications = [
  {
    name: { en: 'Elementary school', ar: 'مرحلة الابتدائية' },
    id: 'elementary'
  },
  { name: { en: 'Middle school', ar: 'مرحلة الإعدادية' }, id: 'middle' },
  { name: { en: 'High school', ar: 'مرحلة الثانوية العامة' }, id: 'secondary' },
  { name: { en: "Bachelor's Degree", ar: 'درجة البكالوريوس' }, id: 'bachelor' },
  { name: { en: "Master's Degree", ar: 'درجة الماجستير' }, id: 'master' },
  { name: { en: 'PhD', ar: 'درجة الدكتوراه' }, id: 'doctorate' }
];

export const Countries = [
  { name: { en: 'Afghanistan', ar: 'أفغانستان' }, id: 'afghanistan' },
  { name: { en: 'Albania', ar: 'ألبانيا' }, id: 'albania' },
  { name: { en: 'Algeria', ar: 'الجزائر' }, id: 'algeria' },
  { name: { en: 'Andorra', ar: 'أندورا' }, id: 'andorra' },
  { name: { en: 'Angola', ar: 'أنغولا' }, id: 'angola' },
  {
    name: { en: 'Antigua and Barbuda', ar: 'أنتيغوا وبربودا' },
    id: 'antigua barbuda'
  },
  { name: { en: 'Argentina', ar: 'الأرجنتين' }, id: 'argentina' },
  { name: { en: 'Armenia', ar: 'أرمينيا' }, id: 'armenia' },
  { name: { en: 'Australia', ar: 'أستراليا' }, id: 'australia' },
  { name: { en: 'Austria', ar: 'النمسا' }, id: 'austria' },
  { name: { en: 'Azerbaijan', ar: 'أذربيجان' }, id: 'azerbaijan' },
  { name: { en: 'Bahamas', ar: 'البهاما' }, id: 'bahamas' },
  { name: { en: 'Bahrain', ar: 'البحرين' }, id: 'bahrain' },
  { name: { en: 'Bangladesh', ar: 'بنغلاديش' }, id: 'bangladesh' },
  { name: { en: 'Barbados', ar: 'بربادوس' }, id: 'barbados' },
  { name: { en: 'Belarus', ar: 'بيلاروسيا' }, id: 'belarus' },
  { name: { en: 'Belgium', ar: 'بلجيكا' }, id: 'belgium' },
  { name: { en: 'Belize', ar: 'بليز' }, id: 'belize' },
  { name: { en: 'Benin', ar: 'بنين' }, id: 'benin' },
  { name: { en: 'Bhutan', ar: 'بوتان' }, id: 'bhutan' },
  { name: { en: 'Bolivia', ar: 'بوليفيا' }, id: 'bolivia' },
  {
    name: { en: 'Bosnia and Herzegovina', ar: 'البوسنة والهرسك' },
    id: 'bosnia herzegovina'
  },
  { name: { en: 'Botswana', ar: 'بوتسوانا' }, id: 'botswana' },
  { name: { en: 'Brazil', ar: 'البرازيل' }, id: 'brazil' },
  { name: { en: 'Brunei', ar: 'بروناي' }, id: 'brunei' },
  { name: { en: 'Bulgaria', ar: 'بلغاريا' }, id: 'bulgaria' },
  { name: { en: 'Burkina Faso', ar: 'بوركينا فاسو' }, id: 'burkina faso' },
  { name: { en: 'Burundi', ar: 'بوروندي' }, id: 'burundi' },
  { name: { en: 'Cabo Verde', ar: 'كابو فيردي' }, id: 'cabo verde' },
  { name: { en: 'Cambodia', ar: 'كمبوديا' }, id: 'cambodia' },
  { name: { en: 'Cameroon', ar: 'الكاميرون' }, id: 'cameroon' },
  { name: { en: 'Canada', ar: 'كندا' }, id: 'canada' },
  {
    name: { en: 'Central African Republic', ar: 'جمهورية افريقيا الوسطى' },
    id: 'central african republic'
  },
  { name: { en: 'Chad', ar: 'تشاد' }, id: 'chad' },
  { name: { en: 'Chile', ar: 'شيلي' }, id: 'chile' },
  { name: { en: 'China', ar: 'الصين' }, id: 'china' },
  { name: { en: 'Colombia', ar: 'كولومبيا' }, id: 'colombia' },
  { name: { en: 'Comoros', ar: 'جزر القمر' }, id: 'comoros' },
  { name: { en: 'Congo', ar: 'الكونغو' }, id: 'congo' },
  { name: { en: 'Costa Rica', ar: 'كوستا ريكا' }, id: 'costa rica' },
  { name: { en: 'Croatia', ar: 'كرواتيا' }, id: 'croatia' },
  { name: { en: 'Cuba', ar: 'كوبا' }, id: 'cuba' },
  { name: { en: 'Cyprus', ar: 'قبرص' }, id: 'cyprus' },
  {
    name: { en: 'Czech Republic', ar: 'الجمهورية التشيكية' },
    id: 'czech republic'
  },
  { name: { en: 'Denmark', ar: 'الدنمارك' }, id: 'denmark' },
  { name: { en: 'Djibouti', ar: 'جيبوتي' }, id: 'djibouti' },
  { name: { en: 'Dominica', ar: 'دومينيكا' }, id: 'dominica' },
  {
    name: { en: 'Dominican Republic', ar: 'جمهورية الدومينيكان' },
    id: 'dominican republic'
  },
  {
    name: { en: 'DR Congo', ar: 'جمهورية الكونغو الديمقراطية' },
    id: 'dr congo'
  },
  { name: { en: 'Ecuador', ar: 'الاكوادور' }, id: 'ecuador' },
  { name: { en: 'Egypt', ar: 'مصر' }, id: 'egypt' },
  { name: { en: 'El Salvador', ar: 'السلفادور' }, id: 'el salvador' },
  {
    name: { en: 'Equatorial Guinea', ar: 'غينيا الإستوائية' },
    id: 'equatorial guinea'
  },
  { name: { en: 'Eritrea', ar: 'إريتريا' }, id: 'eritrea' },
  { name: { en: 'Estonia', ar: 'إستونيا' }, id: 'estonia' },
  { name: { en: 'Eswatini', ar: 'إيسواتيني' }, id: 'eswatini' },
  { name: { en: 'Ethiopia', ar: 'أثيوبيا' }, id: 'ethiopia' },
  { name: { en: 'Faeroe Islands', ar: 'جزر فارو' }, id: 'faeroe islands' },
  { name: { en: 'Fiji', ar: 'فيجي' }, id: 'fiji' },
  { name: { en: 'Finland', ar: 'فنلندا' }, id: 'finland' },
  { name: { en: 'France', ar: 'فرنسا' }, id: 'france' },
  { name: { en: 'Gabon', ar: 'الجابون' }, id: 'gabon' },
  { name: { en: 'Gambia', ar: 'غامبيا' }, id: 'gambia' },
  { name: { en: 'Georgia', ar: 'جورجيا' }, id: 'georgia' },
  { name: { en: 'Germany', ar: 'ألمانيا' }, id: 'germany' },
  { name: { en: 'Ghana', ar: 'غانا' }, id: 'ghana' },
  { name: { en: 'Greece', ar: 'اليونان' }, id: 'greece' },
  { name: { en: 'Grenada', ar: 'غرينادا' }, id: 'grenada' },
  { name: { en: 'Guatemala', ar: 'غواتيمالا' }, id: 'guatemala' },
  { name: { en: 'Guinea', ar: 'غينيا' }, id: 'guinea' },
  { name: { en: 'Guinea-Bissau', ar: 'غينيا بيساو' }, id: 'guinea bissau' },
  { name: { en: 'Guyana', ar: 'غيانا' }, id: 'guyana' },
  { name: { en: 'Haiti', ar: 'هايتي' }, id: 'haiti' },
  { name: { en: 'Honduras', ar: 'هندوراس' }, id: 'honduras' },
  { name: { en: 'Hungary', ar: 'هنغاريا' }, id: 'hungary' },
  { name: { en: 'Iceland', ar: 'أيسلندا' }, id: 'iceland' },
  { name: { en: 'India', ar: 'الهند' }, id: 'india' },
  { name: { en: 'Indonesia', ar: 'إندونيسيا' }, id: 'indonesia' },
  { name: { en: 'Iran', ar: 'إيران' }, id: 'iran' },
  { name: { en: 'Iraq', ar: 'العراق' }, id: 'iraq' },
  { name: { en: 'Ireland', ar: 'أيرلندا' }, id: 'ireland' },
  { name: { en: 'Israel', ar: 'إسرائيل' }, id: 'israel' },
  { name: { en: 'Italy', ar: 'إيطاليا' }, id: 'italy' },
  { name: { en: 'Jamaica', ar: 'جامايكا' }, id: 'jamaica' },
  { name: { en: 'Japan', ar: 'اليابان' }, id: 'japan' },
  { name: { en: 'Jordan', ar: 'الأردن' }, id: 'jordan' },
  { name: { en: 'Kazakhstan', ar: 'كازاخستان' }, id: 'kazakhstan' },
  { name: { en: 'Kenya', ar: 'كينيا' }, id: 'kenya' },
  { name: { en: 'Kuwait', ar: 'الكويت' }, id: 'kuwait' },
  { name: { en: 'Kyrgyzstan', ar: 'قيرغيزستان' }, id: 'kyrgyzstan' },
  { name: { en: 'Laos', ar: 'لاوس' }, id: 'laos' },
  { name: { en: 'Latvia', ar: 'لاتفيا' }, id: 'latvia' },
  { name: { en: 'Lebanon', ar: 'لبنان' }, id: 'lebanon' },
  { name: { en: 'Lesotho', ar: 'ليسوتو' }, id: 'lesotho' },
  { name: { en: 'Liberia', ar: 'ليبيريا' }, id: 'liberia' },
  { name: { en: 'Libya', ar: 'ليبيا' }, id: 'libya' },
  { name: { en: 'Liechtenstein', ar: 'ليختنشتاين' }, id: 'liechtenstein' },
  { name: { en: 'Lithuania', ar: 'ليتوانيا' }, id: 'lithuania' },
  { name: { en: 'Luxembourg', ar: 'لوكسمبورغ' }, id: 'luxembourg' },
  { name: { en: 'Macao', ar: 'ماكاو' }, id: 'macao' },
  { name: { en: 'Madagascar', ar: 'مدغشقر' }, id: 'madagascar' },
  { name: { en: 'Malawi', ar: 'ملاوي' }, id: 'malawi' },
  { name: { en: 'Malaysia', ar: 'ماليزيا' }, id: 'malaysia' },
  { name: { en: 'Maldives', ar: 'جزر المالديف' }, id: 'maldives' },
  { name: { en: 'Mali', ar: 'مالي' }, id: 'mali' },
  { name: { en: 'Malta', ar: 'مالطا' }, id: 'malta' },
  {
    name: { en: 'Marshall Islands', ar: 'جزر مارشال' },
    id: 'marshall islands'
  },
  { name: { en: 'Mauritania', ar: 'موريتانيا' }, id: 'mauritania' },
  { name: { en: 'Mauritius', ar: 'موريشيوس' }, id: 'mauritius' },
  { name: { en: 'Mexico', ar: 'المكسيك' }, id: 'mexico' },
  { name: { en: 'Micronesia', ar: 'ميكرونيزيا' }, id: 'micronesia' },
  { name: { en: 'Moldova', ar: 'مولدوفا' }, id: 'moldova' },
  { name: { en: 'Monaco', ar: 'موناكو' }, id: 'monaco' },
  { name: { en: 'Mongolia', ar: 'منغوليا' }, id: 'mongolia' },
  { name: { en: 'Montenegro', ar: 'الجبل الأسود' }, id: 'montenegro' },
  { name: { en: 'Morocco', ar: 'المغرب' }, id: 'morocco' },
  { name: { en: 'Mozambique', ar: 'موزمبيق' }, id: 'mozambique' },
  { name: { en: 'Myanmar', ar: 'ميانمار' }, id: 'myanmar' },
  { name: { en: 'Namibia', ar: 'ناميبيا' }, id: 'namibia' },
  { name: { en: 'Nauru', ar: 'ناورو' }, id: 'nauru' },
  { name: { en: 'Nepal', ar: 'نيبال' }, id: 'nepal' },
  { name: { en: 'Netherlands', ar: 'هولندا' }, id: 'netherlands' },
  { name: { en: 'New Zealand', ar: 'نيوزيلندا' }, id: 'new zealand' },
  { name: { en: 'Nicaragua', ar: 'نيكاراغوا' }, id: 'nicaragua' },
  { name: { en: 'Niger', ar: 'النيجر' }, id: 'niger' },
  { name: { en: 'Nigeria', ar: 'نيجيريا' }, id: 'nigeria' },
  { name: { en: 'North Korea', ar: 'كوريا الشمالية' }, id: 'north korea' },
  {
    name: { en: 'North Macedonia', ar: 'مقدونيا الشمالية' },
    id: 'north macedonia'
  },
  { name: { en: 'Norway', ar: 'النرويج' }, id: 'norway' },
  { name: { en: 'Oman', ar: 'سلطنة عمان' }, id: 'oman' },
  { name: { en: 'Pakistan', ar: 'باكستان' }, id: 'pakistan' },
  { name: { en: 'Palau', ar: 'بالاو' }, id: 'palau' },
  { name: { en: 'Palestine', ar: 'فلسطين' }, id: 'palestine' },
  { name: { en: 'Panama', ar: 'بنما' }, id: 'panama' },
  {
    name: { en: 'Papua New Guinea', ar: 'بابوا غينيا الجديدة' },
    id: 'papua new guinea'
  },
  { name: { en: 'Paraguay', ar: 'باراجواي' }, id: 'paraguay' },
  { name: { en: 'Peru', ar: 'بيرو' }, id: 'peru' },
  { name: { en: 'Philippines', ar: 'الفلبين' }, id: 'philippines' },
  { name: { en: 'Poland', ar: 'بولندا' }, id: 'poland' },
  { name: { en: 'Portugal', ar: 'البرتغال' }, id: 'portugal' },
  { name: { en: 'Qatar', ar: 'دولة قطر' }, id: 'qatar' },
  { name: { en: 'Romania', ar: 'رومانيا' }, id: 'romania' },
  { name: { en: 'Russia', ar: 'روسيا' }, id: 'russia' },
  { name: { en: 'Rwanda', ar: 'رواندا' }, id: 'rwanda' },
  {
    name: { en: 'Saint Kitts and Nevis', ar: 'سانت كيتس ونيفيس' },
    id: 'saint kitts nevis'
  },
  { name: { en: 'Saint Lucia', ar: 'القديسة لوسيا' }, id: 'saint lucia' },
  {
    name: {
      en: 'Saint Vincent and the Grenadines',
      ar: 'سانت فنسنت وجزر غرينادين'
    },
    id: 'saint vincent grenadines'
  },
  { name: { en: 'Samoa', ar: 'ساموا' }, id: 'samoa' },
  { name: { en: 'San Marino', ar: 'سان مارينو' }, id: 'san marino' },
  {
    name: { en: 'Sao Tome and Principe', ar: 'سان تومي وبرينسيبي' },
    id: 'sao tome principe'
  },
  {
    name: { en: 'Saudi Arabia', ar: 'المملكة العربية السعودية' },
    id: 'saudi arabia'
  },
  { name: { en: 'Senegal', ar: 'السنغال' }, id: 'senegal' },
  { name: { en: 'Serbia', ar: 'صربيا' }, id: 'serbia' },
  { name: { en: 'Seychelles', ar: 'سيشيل' }, id: 'seychelles' },
  { name: { en: 'Sierra Leone', ar: 'سيرا ليون' }, id: 'sierra leone' },
  { name: { en: 'Singapore', ar: 'سنغافورة' }, id: 'singapore' },
  { name: { en: 'Slovakia', ar: 'سلوفاكيا' }, id: 'slovakia' },
  { name: { en: 'Slovenia', ar: 'سلوفينيا' }, id: 'slovenia' },
  { name: { en: 'Solomon Islands', ar: 'جزر سليمان' }, id: 'solomon islands' },
  { name: { en: 'Somalia', ar: 'الصومال' }, id: 'somalia' },
  { name: { en: 'South Africa', ar: 'جنوب أفريقيا' }, id: 'south africa' },
  { name: { en: 'South Korea', ar: 'كوريا الجنوبية' }, id: 'south korea' },
  { name: { en: 'South Sudan', ar: 'جنوب السودان' }, id: 'south sudan' },
  { name: { en: 'Spain', ar: 'إسبانيا' }, id: 'spain' },
  { name: { en: 'Sri Lanka', ar: 'سيريلانكا' }, id: 'sri lanka' },
  { name: { en: 'Sudan', ar: 'السودان' }, id: 'sudan' },
  { name: { en: 'Suriname', ar: 'سورينام' }, id: 'suriname' },
  { name: { en: 'Sweden', ar: 'السويد' }, id: 'sweden' },
  { name: { en: 'Switzerland', ar: 'سويسرا' }, id: 'switzerland' },
  { name: { en: 'Syria', ar: 'سوريا' }, id: 'syria' },
  { name: { en: 'Tajikistan', ar: 'طاجيكستان' }, id: 'tajikistan' },
  { name: { en: 'Tanzania', ar: 'تنزانيا' }, id: 'tanzania' },
  { name: { en: 'Thailand', ar: 'تايلاند' }, id: 'thailand' },
  { name: { en: 'Timor-Leste', ar: 'تيمور الشرقية' }, id: 'timor leste' },
  { name: { en: 'Togo', ar: 'توجو' }, id: 'togo' },
  { name: { en: 'Tonga', ar: 'تونغا' }, id: 'tonga' },
  {
    name: { en: 'Trinidad and Tobago', ar: 'ترينداد وتوباغو' },
    id: 'trinidad tobago'
  },
  { name: { en: 'Tunisia', ar: 'تونس' }, id: 'tunisia' },
  { name: { en: 'Turkey', ar: 'ديك رومى' }, id: 'turkey' },
  { name: { en: 'Turkmenistan', ar: 'تركمانستان' }, id: 'turkmenistan' },
  { name: { en: 'Tuvalu', ar: 'توفالو' }, id: 'tuvalu' },
  { name: { en: 'Uganda', ar: 'أوغندا' }, id: 'uganda' },
  { name: { en: 'Ukraine', ar: 'أوكرانيا' }, id: 'ukraine' },
  {
    name: { en: 'United Arab Emirates', ar: 'الإمارات العربية المتحدة' },
    id: 'united arab emirates'
  },
  {
    name: { en: 'United Kingdom', ar: 'المملكة المتحدة' },
    id: 'united kingdom'
  },
  {
    name: { en: 'United States', ar: 'الولايات المتحدة' },
    id: 'united states'
  },
  { name: { en: 'Uruguay', ar: 'الأوروغواي' }, id: 'uruguay' },
  { name: { en: 'Uzbekistan', ar: 'أوزبكستان' }, id: 'uzbekistan' },
  { name: { en: 'Vanuatu', ar: 'فانواتو' }, id: 'vanuatu' },
  { name: { en: 'Vatican City', ar: 'الفاتيكان' }, id: 'vatican city' },
  { name: { en: 'Venezuela', ar: 'فنزويلا' }, id: 'venezuela' },
  { name: { en: 'Vietnam', ar: 'فيتنام' }, id: 'vietnam' },
  { name: { en: 'Yemen', ar: 'اليمن' }, id: 'yemen' },
  { name: { en: 'Zambia', ar: 'زامبيا' }, id: 'zambia' },
  { name: { en: 'Zimbabwe', ar: 'زيمبابوي' }, id: 'zimbabwe' }
];

export const Nationality_NewStudent = [
  {
    name: {
      en: 'No identification papers',
      ar: 'لا يحمل أوراق ثبوتية',
    },
    id: 'noIdentificationPapers',
    noSort: true
  },
  ...Nationalities
];

export const Languages = [
  { name: { en: 'Mandarin', ar: 'الصينية المندرينية' }, id: 'mandarin' },
  { name: { en: 'Spanish', ar: 'الإسبانية' }, id: 'spanish' },
  { name: { en: 'English', ar: 'الإنجليزية' }, id: 'english' },
  { name: { en: 'Hindi', ar: 'الهندية' }, id: 'hindi' },
  { name: { en: 'Arabic', ar: 'العربية' }, id: 'arabic' },
  { name: { en: 'Portuguese', ar: 'البرتغالية' }, id: 'portuguese' },
  { name: { en: 'Bengali', ar: 'البنغالية' }, id: 'bengali' },
  { name: { en: 'Russian', ar: 'الروسية' }, id: 'russian' },
  { name: { en: 'Japanese', ar: 'اليابانية' }, id: 'japanese' },
  { name: { en: 'Punjabi', ar: 'البنجابية' }, id: 'punjabi' },
  { name: { en: 'German', ar: 'الألمانية' }, id: 'german' },
  { name: { en: 'Javanese', ar: 'الجاوية' }, id: 'javanese' },
  {
    name: {
      en: 'Wu (inc. Shanghainese)',
      ar: 'اللغة الوو (بما في ذلك الشنغهاي)'
    },
    id: 'wu_shanghainese'
  },
  {
    name: { en: 'Malay/Indonesian', ar: 'اللغة الملاوية/الإندونيسية' },
    id: 'malay indonesian'
  },
  { name: { en: 'Telugu', ar: 'التيلجو' }, id: 'telugu' },
  { name: { en: 'Vietnamese', ar: 'الفيتنامية' }, id: 'vietnamese' },
  { name: { en: 'Korean', ar: 'الكورية' }, id: 'korean' },
  { name: { en: 'French', ar: 'الفرنسية' }, id: 'french' },
  { name: { en: 'Marathi', ar: 'المراثية' }, id: 'marathi' },
  { name: { en: 'Tamil', ar: 'التاميلية' }, id: 'tamil' },
  { name: { en: 'Urdu', ar: 'الأردية' }, id: 'urdu' },
  { name: { en: 'Turkish', ar: 'التركية' }, id: 'turkish' },
  { name: { en: 'Italian', ar: 'الإيطالية' }, id: 'italian' },
  {
    name: { en: 'Yue (Cantonese)', ar: 'اليوي (الكانتونية)' },
    id: 'yue cantonese'
  },
  { name: { en: 'Thai', ar: 'التايلاندية' }, id: 'thai' },
  { name: { en: 'Gujarati', ar: 'الغوجاراتية' }, id: 'gujarati' },
  { name: { en: 'Jin', ar: 'الجين' }, id: 'jin' },
  {
    name: { en: 'Southern Min', ar: 'اللغة الجنوبية الصينية' },
    id: 'southern min'
  },
  { name: { en: 'Persian', ar: 'الفارسية' }, id: 'persian' },
  { name: { en: 'Polish', ar: 'البولندية' }, id: 'polish' },
  { name: { en: 'Pashto', ar: 'الباشتو' }, id: 'pashto' },
  { name: { en: 'Kannada', ar: 'الكانادا' }, id: 'kannada' },
  {
    name: { en: 'Xiang (Hunnanese)', ar: 'الشيانج (الهونانية)' },
    id: 'xiang hunnanese'
  },
  { name: { en: 'Malayalam', ar: 'الماليالامية' }, id: 'malayalam' },
  { name: { en: 'Sundanese', ar: 'السندانيزية' }, id: 'sundanese' },
  { name: { en: 'Hausa', ar: 'الهاوسا' }, id: 'hausa' },
  { name: { en: 'Odia (Oriya)', ar: 'الأودية (الأوريا)' }, id: 'odia oriya' },
  { name: { en: 'Burmese', ar: 'البورمية' }, id: 'burmese' },
  { name: { en: 'Hakka', ar: 'الهاكا' }, id: 'hakka' },
  { name: { en: 'Ukrainian', ar: 'الأوكرانية' }, id: 'ukrainian' },
  { name: { en: 'Bhojpuri', ar: 'البهوجبورية' }, id: 'bhojpuri' },
  { name: { en: 'Tagalog', ar: 'التاغالوغية' }, id: 'tagalog' },
  { name: { en: 'Yoruba', ar: 'اليوروبية' }, id: 'yoruba' },
  { name: { en: 'Maithili', ar: 'المايثيلية' }, id: 'maithili' },
  { name: { en: 'Uzbek', ar: 'الأوزبكية' }, id: 'uzbek' },
  { name: { en: 'Sindhi', ar: 'السندية' }, id: 'sindhi' },
  { name: { en: 'Amharic', ar: 'الأمهرية' }, id: 'amharic' },
  { name: { en: 'Fula', ar: 'الفولا' }, id: 'fula' },
  { name: { en: 'Romanian', ar: 'الرومانية' }, id: 'romanian' },
  { name: { en: 'Oromo', ar: 'الأورومو' }, id: 'oromo' },
  { name: { en: 'Igbo', ar: 'الإيجبو' }, id: 'igbo' },
  { name: { en: 'Azerbaijani', ar: 'الأذربيجانية' }, id: 'azerbaijani' },
  { name: { en: 'Awadhi', ar: 'الأوادي' }, id: 'awadhi' },
  { name: { en: 'Gan Chinese', ar: 'الجان الصينية' }, id: 'gan chinese' },
  {
    name: { en: 'Cebuano (Visayan)', ar: 'سيبوانو (فيسايان)' },
    id: 'cebuano visayan'
  },
  { name: { en: 'Dutch', ar: 'الهولندية' }, id: 'dutch' },
  { name: { en: 'Kurdish', ar: 'الكردية' }, id: 'kurdish' },
  {
    name: { en: 'Serbo-Croatian', ar: 'الصربية الكرواتية' },
    id: 'serbo croatian'
  },
  { name: { en: 'Malagasy', ar: 'المالغاشية' }, id: 'malagasy' },
  { name: { en: 'Saraiki', ar: 'السرائيكية' }, id: 'saraiki' },
  { name: { en: 'Nepali', ar: 'النيبالية' }, id: 'nepali' },
  { name: { en: 'Sinhalese', ar: 'السنهالية' }, id: 'sinhalese' },
  { name: { en: 'Chittagonian', ar: 'تشيتاجونيان' }, id: 'chittagonian' },
  { name: { en: 'Zhuang', ar: 'الزوانج' }, id: 'zhuang' },
  { name: { en: 'Khmer', ar: 'الخميرية' }, id: 'khmer' },
  { name: { en: 'Turkmen', ar: 'التركمانية' }, id: 'turkmen' },
  { name: { en: 'Assamese', ar: 'الأسامية' }, id: 'assamese' },
  { name: { en: 'Madurese', ar: 'المادورية' }, id: 'madurese' },
  { name: { en: 'Somali', ar: 'الصومالية' }, id: 'somali' },
  { name: { en: 'Marwari', ar: 'الماروارية' }, id: 'marwari' },
  { name: { en: 'Magahi', ar: 'الماجاهي' }, id: 'magahi' },
  { name: { en: 'Haryanvi', ar: 'الهاريانفي' }, id: 'haryanvi' },
  { name: { en: 'Hungarian', ar: 'المجرية' }, id: 'hungarian' },
  { name: { en: 'Chhattisgarhi', ar: 'الشاتيسغارية' }, id: 'chhattisgarhi' },
  { name: { en: 'Greek', ar: 'اليونانية' }, id: 'greek' },
  { name: { en: 'Chewa', ar: 'التشيوا' }, id: 'chewa' },
  { name: { en: 'Deccan', ar: 'الديكانية' }, id: 'deccan' },
  { name: { en: 'Akan', ar: 'الأكان' }, id: 'akan' },
  { name: { en: 'Kazakh', ar: 'الكازاخية' }, id: 'kazakh' },
  { name: { en: 'Northern Min', ar: 'المين الشمالية' }, id: 'northern min' },
  { name: { en: 'Sylheti', ar: 'السيلهيتية' }, id: 'sylheti' },
  { name: { en: 'Zulu', ar: 'الزولو' }, id: 'zulu' },
  { name: { en: 'Czech', ar: 'التشيكية' }, id: 'czech' },
  { name: { en: 'Kinyarwanda', ar: 'الكينيارواندا' }, id: 'kinyarwanda' },
  { name: { en: 'Dhundhari', ar: 'الدهنداري' }, id: 'dhundhari' },
  {
    name: { en: 'Haitian Creole', ar: 'الكريولية الهايتية' },
    id: 'haitian creole'
  },
  { name: { en: 'Eastern Min', ar: 'المين الشرقية' }, id: 'eastern min' },
  { name: { en: 'Ilocano', ar: 'الإيلوكانو' }, id: 'ilocano' },
  { name: { en: 'Quechua', ar: 'الكيتشوا' }, id: 'quechua' },
  { name: { en: 'Kirundi', ar: 'الكيروندية' }, id: 'kirundi' },
  { name: { en: 'Swedish', ar: 'السويدية' }, id: 'swedish' },
  { name: { en: 'Hmong', ar: 'الهمونج' }, id: 'hmong' },
  { name: { en: 'Shona', ar: 'الشونا' }, id: 'shona' },
  { name: { en: 'Uyghur', ar: 'الأويغورية' }, id: 'uyghur' },
  { name: { en: 'Hiligaynon', ar: 'الهيليجاينون' }, id: 'hiligaynon' },
  { name: { en: 'Mossi', ar: 'الموسي' }, id: 'mossi' },
  { name: { en: 'Xhosa', ar: 'الخوسا' }, id: 'xhosa' },
  { name: { en: 'Belarusian', ar: 'البيلاروسية' }, id: 'belarusian' },
  { name: { en: 'Balochi', ar: 'البلوشية' }, id: 'balochi' },
  { name: { en: 'Konkani', ar: 'الكونكانية' }, id: 'konkani' }
];

export const YesAndNo = [
  {
    name: { en: 'Yes', ar: 'نعم' },
    id: 'Yes'
  },
  {
    name: { en: 'No', ar: 'لا' },
    id: 'No'
  }
];

export const Gender = [
  {
    name: { en: 'Male', ar: 'ذكر' },
    id: 'male'
  },
  {
    name: { en: 'Female', ar: 'انثى' },
    id: 'female'
  }
];

export const StudentGender = [
  { name: { en: 'Boys', ar: 'بنين' }, id: 'male' },
  {
    name: { en: 'Girls', ar: 'بنات' },
    id: 'female'
  },
  {
    name: { en: 'Boys and Girls', ar: 'بنين و بنات' },
    id: 'mixed'
  }
];

export const LandOwnershipTypes = [
  {
    name: { en: 'Private', ar: 'ملك' },
    id: 'private'
  },
  {
    name: { en: 'Grant', ar: 'منحة ' },
    id: 'grant'
  },
  {
    name: { en: 'Rent', ar: 'إيجار' },
    id: 'rent'
  }
];

export const BuildingOwnershipTypes = [
  {
    name: { en: 'Private', ar: 'ملك' },
    id: 'private'
  },
  {
    name: { en: 'Rent', ar: 'إيجار' },
    id: 'rent'
  }
];

export const EducationLevels = [
  {
    name: { en: 'Pre-kindergarten', ar: 'ما قبل رياض الاطفال' },
    id: 'pre-kindergarten'
  },
  {
    name: { en: 'First kindergarten', ar: 'الروضة الاولي' },
    id: 'first-kindergarten'
  },
  {
    name: { en: 'Second kindergarten', ar: 'الروضة الثانية' },
    id: 'second-kindergarten'
  },
  { name: { en: 'Level 1', ar: 'المرحلة 1' }, id: 'level-1' },
  { name: { en: 'Level 2', ar: 'المرحلة 2' }, id: 'level-2' },
  { name: { en: 'Level 3', ar: 'المرحلة 3' }, id: 'level-3' },
  { name: { en: 'Level 4', ar: 'المرحلة 4' }, id: 'level-4' },
  { name: { en: 'Level 5', ar: 'المرحلة 5' }, id: 'level-5' },
  { name: { en: 'Level 6', ar: 'المرحلة 6' }, id: 'level-6' },
  { name: { en: 'Level 7', ar: 'المرحلة 7' }, id: 'level-7' },
  { name: { en: 'Level 8', ar: 'المرحلة 8' }, id: 'level-8' },
  { name: { en: 'Level 9', ar: 'المرحلة 9' }, id: 'level-9' },
  { name: { en: 'Level 10', ar: 'المرحلة 10' }, id: 'level-10' },
  { name: { en: 'Level 11', ar: 'المرحلة 11' }, id: 'level-11' },
  { name: { en: 'Level 12', ar: 'المرحلة 12' }, id: 'level-12' }
];
export const TypesOfHiring = [
  { name: { en: 'Permanent notification', ar: 'إخطار دائم' }, id: 'permanent' },
  { name: { en: 'Temporary notification', ar: 'إخطار مؤقت' }, id: 'temporary' }
];
// export const TypeOfStudents = [
//   { name: { en: 'Boys', ar: 'بنين' }, id: 'boys' },
//   { name: { en: 'Girls', ar: 'بنات' }, id: 'girls' },
//   { name: { en: 'Mixed', ar: 'مختلط' }, id: 'mixed' },
// ];

export const ReasonOfCancelation = [
  { name: { en: 'Financial reasons', ar: 'أسباب مالية' }, id: 'financial' },
  { name: { en: 'Security reasons', ar: 'أسباب أمنية' }, id: 'security' },
  { name: { en: 'Other reasons', ar: 'أسباب أخرى' }, id: 'other' }
];

export const Jobs = [
  { name: { en: 'Job 1', ar: 'وظيفة 1' }, id: 'job1' },
  { name: { en: 'Job 2', ar: 'وظيفة 2' }, id: 'job2' },
  { name: { en: 'Job 3', ar: 'وظيفة 3' }, id: 'job3' },
  { name: { en: 'Job 4', ar: 'وظيفة 4' }, id: 'job4' },
  { name: { en: 'Job 5', ar: 'وظيفة 5' }, id: 'job5' }
];
export const eventTypes = [
  { name: { en: 'Lecture', ar: 'محاضرة' }, id: 'lecture' },
  { name: { en: 'Seminar', ar: 'ندوة' }, id: 'seminar' },
  { name: { en: 'Workshop', ar: 'ورشة' }, id: 'workshop' },
  { name: { en: 'Book Fair', ar: 'معرض كتاب' }, id: 'bookFair' },
  { name: { en: 'Fair', ar: 'معرض' }, id: 'Fair' },
  { name: { en: 'Training', ar: 'تدريب' }, id: 'training' },
  { name: { en: 'Other', ar: 'أخرى' }, id: 'other' }
];
export const NameOfSpaces = [
  {
    name: {
      en: 'Manager Room',
      ar: 'غرفة المدير'
    },
    id: 'manager room'
  },
  {
    name: {
      en: 'Secretary Room',
      ar: 'غرفة السكرتارية'
    },
    id: 'secretary room'
  },
  {
    name: {
      en: 'Male Faculty Room',
      ar: 'غرفة الهيئة التدريسية للذكور'
    },
    id: 'male faculty room'
  },
  {
    name: {
      en: 'Female Faculty Room',
      ar: 'غرفة الهيئة التدريسية للإناث'
    },
    id: 'female faculty room'
  },
  {
    name: {
      en: 'Administrative Activities Room',
      ar: 'غرفة أنشطة إدارية'
    },
    id: 'admin activities room'
  },
  {
    name: {
      en: 'General Science Lab',
      ar: 'مختبر علوم عامة'
    },
    id: 'general science lab'
  },
  {
    name: {
      en: 'Physics Lab',
      ar: 'مختبر فيزياء'
    },
    id: 'physics lab'
  },
  {
    name: {
      en: 'Chemistry Lab',
      ar: 'مختبر كيمياء'
    },
    id: 'chemistry lab'
  },
  {
    name: {
      en: 'Chemistry Lab Preparation Room',
      ar: 'غرفة تحضير لمختبر كيمياء'
    },
    id: 'chemistry lab preparation room'
  },
  {
    name: {
      en: 'Biology and Geology Lab',
      ar: 'مختبر أحياء و جيولوجيا'
    },
    id: 'biology geology lab'
  },
  {
    name: {
      en: 'Fine Arts Room',
      ar: 'غرفة تربية فنية'
    },
    id: 'fine arts room'
  },
  {
    name: {
      en: 'Computer Room',
      ar: 'غرفة حاسوب'
    },
    id: 'computer room'
  },
  {
    name: {
      en: 'Language Lab',
      ar: 'مختبر لغة'
    },
    id: 'language lab'
  },
  {
    name: {
      en: 'Library',
      ar: 'مكتبة'
    },
    id: 'library'
  },
  {
    name: {
      en: 'Multipurpose Activities Hall',
      ar: 'قاعة أنشطة متعددة الاغراض'
    },
    id: 'multipurpose hall'
  },
  {
    name: {
      en: 'Indoor Games Hall',
      ar: 'صالة ألعاب مغلقة'
    },
    id: 'indoor games hall'
  },
  {
    name: {
      en: 'Theater',
      ar: 'مسرح'
    },
    id: 'theater'
  }
];

export const RequestTypes = [
  {
    name: {
      en: 'New Request',
      ar: 'طلب جديد'
    },
    id: 'New Request'
  },
  {
    name: {
      en: 'Add',
      ar: 'إضافة'
    },
    id: 'Add'
  }
];

export const Emirates = [
  {
    name: {
      en: 'Abu Dhabi',
      ar: 'أبو ظبي'
    },
    id: 'abu-dhabi'
  },
  {
    name: {
      en: 'Dubai',
      ar: 'دبي'
    },
    id: 'dubai'
  },
  {
    name: {
      en: 'Sharjah',
      ar: 'الشارقة'
    },
    id: 'sharjah'
  },
  {
    name: {
      en: 'Ajman',
      ar: 'عجمان'
    },
    id: 'ajman'
  },
  {
    name: {
      en: 'Umm Al-Quwain',
      ar: 'أم القيوين'
    },
    id: 'umm-al-quwain'
  },
  {
    name: {
      en: 'Fujairah',
      ar: 'الفجيرة'
    },
    id: 'fujairah'
  },
  {
    name: {
      en: 'Ras Al Khaimah',
      ar: 'رأس الخيمة'
    },
    id: 'ras-al-khaimah'
  }
];

export const CurriculumFollowed = [
  {
    name: {
      en: 'American Curriculum',
      ar: 'المنهاج الأمريكي'
    },
    id: 'American Curriculum'
  },
  {
    name: {
      en: 'Bangladeshi Curriculum',
      ar: 'المنهاج البنغالي'
    },
    id: 'Bangladeshi Curriculum'
  },
  {
    name: {
      en: 'British Curriculum',
      ar: 'المنهاج البريطاني'
    },
    id: 'British Curriculum'
  },
  {
    name: {
      en: 'Canadian Curriculum',
      ar: 'المنهاج الكندي'
    },
    id: 'Canadian Curriculum'
  },
  {
    name: {
      en: 'French Curriculum',
      ar: 'المنهاج الفرنسي'
    },
    id: 'French Curriculum'
  },
  {
    name: {
      en: 'German Curriculum',
      ar: 'المنهاج الألماني'
    },
    id: 'German Curriculum'
  },
  {
    name: {
      en: 'Indian curriculum',
      ar: 'المنهاج الهندي'
    },
    id: 'Indian curriculum'
  },
  {
    name: {
      en: 'Pakistani curriculum',
      ar: 'المنهاج الباكستاني'
    },
    id: 'Pakistani curriculum'
  },
  {
    name: {
      en: 'International private curriculum',
      ar: 'المنهاج الدولي الخاص'
    },
    id: 'International private curriculum'
  },
  {
    name: {
      en: 'Australian curriculum',
      ar: 'المنهاج الأسترالي'
    },
    id: 'Australian curriculum'
  },
  {
    name: {
      en: 'Private Baccalaureate',
      ar: 'البكالوريا الخاص'
    },
    id: 'Private Baccalaureate'
  }
];

export const SchoolRequestTypes = [
  {
    name: {
      en: 'Modification of existing building',
      ar: 'تعديل على مبنى قائم'
    },
    id: 'Modification of existing building'
  },
  {
    name: {
      en: 'Add facilities',
      ar: 'اضافة مرافق'
    },
    id: 'Add facilities'
  }
];
export const ActivityTime = [
  {
    name: {
      en: 'Outside working hours',
      ar: 'خارج ساعات العمل'
    },
    id: 'Outside working hours'
  },
  {
    name: {
      en: 'Within working hours',
      ar: 'داخل ساعات العمل'
    },
    id: 'Within working hours'
  }
];

export const ActivityType = [
  {
    name: {
      en: 'Strengthening lessons',
      ar: 'دروس تقوية'
    },
    id: 'Strengthening lessons'
  },
  {
    name: {
      en: 'Sports such as (football - handball - swimming... etc.)',
      ar: ' الرياضات مثل (كرة القدم - كرة اليد - السباحة....الخ)'
    },
    id: 'Sports'
  },
  {
    name: {
      en: 'Handicrafts',
      ar: 'الحرف اليدوية'
    },
    id: 'Handicrafts'
  },
  {
    name: {
      en: 'Music',
      ar: 'موسيقى'
    },
    id: 'Music'
  },
  {
    name: {
      en: 'Drawing',
      ar: 'رسم'
    },
    id: 'Drawing'
  },
  {
    name: {
      en: 'Other',
      ar: 'أخرى'
    },
    id: 'Other'
  }
];

export const Semester = [
  {
    name: {
      en: 'First Semester',
      ar: 'الفصل الدراسى الأول'
    },
    id: 'First Semester'
  },
  {
    name: {
      en: 'Second Semester',
      ar: 'الفصل الدراسى الثانى'
    },
    id: 'Second Semester'
  }
];

export const ChangeSchoolLocationTypes = [
  {
    name: {
      en: 'New building',
      ar: 'بناء جديد'
    },
    id: 'New building'
  },
  {
    name: {
      en: 'Change School Location',
      ar: 'تغيير موقع المدرسة'
    },
    id: 'Change School Location'
  }
];

export const NewRequestTypes = [
  {
    name: {
      en: 'New building - empty land to be built on',
      ar: 'بناء جديد - ارض خالية المراد بناء عليها'
    },
    id: 'New building'
  },
  {
    name: {
      en: 'Addition - modification to an existing building or addition of facilities',
      ar: 'اضافة - تعديل على مبنى قائم او اضافة مرافق'
    },
    id: 'Addition'
  }
  // {
  //   name: {
  //     en: 'Change School Location',
  //     ar: 'تغيير موقع المدرسة',
  //   },
  //   id: 'Change School Location',
  // },
];

export const ChannelsList = [
  {
    name: {
      en: 'Social media',
      ar: 'وسائل التواصل الاجتماعي'
    },
    id: 'Social media'
  },
  {
    name: {
      en: 'Outdoor advertisements (billboards on roads and public places)',
      ar: 'الاعلانات الخارجية( اللوحات الاعلانية في الطرق و الأماكن العامة )'
    },
    id: 'Outdoor advertisements (billboards on roads and public places)'
  },
  {
    name: {
      en: 'Video ads on YouTube',
      ar: 'إعلانات الفيديو على اليوتيوب'
    },
    id: 'Video ads on YouTube'
  },
  {
    name: {
      en: 'Ads through search engines',
      ar: 'إعلانات عبر محركات البحث'
    },
    id: 'Ads through search engines'
  },
  {
    name: {
      en: 'Email advertisements',
      ar: 'الاعلانات البريدية'
    },
    id: 'Email advertisements'
  },
  {
    name: {
      en: 'Telemarketing',
      ar: 'التسويق عن طريق المكالمات الهاتفية '
    },
    id: 'Telemarketing'
  },
  {
    name: {
      en: 'Radio and television',
      ar: 'الإذاعة و التلفزيون'
    },
    id: 'Radio and television'
  },
  {
    name: {
      en: 'Newspapers and magazines',
      ar: 'الصحف و المجلات'
    },
    id: 'Newspapers and magazines'
  },
  {
    name: {
      en: 'Other',
      ar: 'أخرى'
    },
    id: 'Other'
  }
];

export const StudentRegistrationTypes_NewStudent = [
  {
    name: { en: 'New Student', ar: 'طالب جديد' },
    id: StudentRegistrationTypes.NewStudent
  },
  {
    name: {
      en: 'Transferred From Public School Outside The Country',
      ar: 'منقول من مدرسة عامة خارج الدولة'
    },
    id: StudentRegistrationTypes.PublicSchoolAbroad
  },
  {
    name: {
      en: 'Transferred From Private School Inside The Country',
      ar: 'منقول من مدرسة خاصة داخل الدولة'
    },
    id: StudentRegistrationTypes.PrivateSchoolLocal
  },
  {
    name: {
      en: 'Transferred From Private School Outside The Country',
      ar: 'منقول من مدرسة خاصة خارج الدولة'
    },
    id: StudentRegistrationTypes.PrivateSchoolAbroad
  },
  {
    name: {
      en: 'Transferred From Public School Inside The Country',
      ar: 'منقول من مدرسة عامة داخل الدولة'
    },
    id: StudentRegistrationTypes.PublicSchoolLocal
  },
  {
    name: { en: 'Level Setting', ar: 'تحديد مستوى' },
    id: StudentRegistrationTypes.LevelSetting
  }
];

export const StudentRegistrationTypes_CurrentStudent = [
  {
    name: { en: 'Re-registered', ar: 'معاد قيده' },
    id: StudentRegistrationTypes.ReRegistered
  },
  {
    name: { en: 'Transfer from another curriculum', ar: 'انتقال من منهج أخر' },
    id: StudentRegistrationTypes.AnotherCurriculum
  },
  {
    name: {
      en: 'Transferring from a private school inside Ajman',
      ar: 'انتقال من مدرسة خاصة داخل عجمان'
    },
    id: StudentRegistrationTypes.PrivateSchoolAjman
  },
  {
    name: { en: 'Level Setting', ar: 'تحديد مستوى' },
    id: StudentRegistrationTypes.LevelSetting
  }
];

export const StudentRegistrationTypes_General = [
  {
    name: { en: 'New Student', ar: 'طالب جديد' },
    id: StudentRegistrationTypes.NewStudent
  },
  {
    name: {
      en: 'Transferred From Public School Outside The Country',
      ar: 'منقول من مدرسة عامة خارج الدولة'
    },
    id: StudentRegistrationTypes.PublicSchoolAbroad
  },
  {
    name: {
      en: 'Transferred From Private School Inside The Country',
      ar: 'منقول من مدرسة خاصة داخل الدولة'
    },
    id: StudentRegistrationTypes.PrivateSchoolLocal
  },
  {
    name: {
      en: 'Transferred From Private School Outside The Country',
      ar: 'منقول من مدرسة خاصة خارج الدولة'
    },
    id: StudentRegistrationTypes.PrivateSchoolAbroad
  },
  {
    name: {
      en: 'Transferred From Public School Inside The Country',
      ar: 'منقول من مدرسة عامة داخل الدولة'
    },
    id: StudentRegistrationTypes.PublicSchoolLocal
  },
  { name: { en: 'Re-registered', ar: 'معاد قيده' }, id: 'Re-registered' },
  {
    name: { en: 'Transfer from another curriculum', ar: 'انتقال من منهج أخر' },
    id: StudentRegistrationTypes.AnotherCurriculum
  },
  {
    name: {
      en: 'Transferring from a private school inside Ajman',
      ar: 'انتقال من مدرسة خاصة داخل عجمان'
    },
    id: StudentRegistrationTypes.PrivateSchoolAjman
  },
  {
    name: { en: 'Level Setting', ar: 'تحديد مستوى' },
    id: StudentRegistrationTypes.LevelSetting
  }
];

export const Relationship = [
  { name: { en: 'Father', ar: 'أب' }, id: 'Father' },
  { name: { en: 'Mother', ar: 'أم' }, id: 'Mother' },
  { name: { en: 'Grandfather', ar: 'جد' }, id: 'Grandfather' },
  { name: { en: 'Brother', ar: 'أخ' }, id: 'Brother' },
  { name: { en: 'Maternal Uncle', ar: 'خال' }, id: 'Maternal Uncle' },
  { name: { en: 'Uncle', ar: 'عم' }, id: 'Uncle' },
  { name: { en: 'Other', ar: 'أخرى' }, id: 'Other' }
];

export const GuardianType = [
  { name: { en: 'Father', ar: 'الأب' }, id: 'Father' },
  { name: { en: 'Mother', ar: 'الأم' }, id: 'Mother' },
  { name: { en: 'Stepfather', ar: 'زوج الأم' }, id: 'Stepfather' },
  { name: { en: 'Stepmother', ar: 'زوجة الأب' }, id: 'Stepmother' },
  { name: { en: 'Grandfather', ar: 'الجد' }, id: 'Grandfather' },
  { name: { en: 'Grandmother', ar: 'الجدة' }, id: 'Grandmother' },
  { name: { en: 'Brother', ar: 'الأخ' }, id: 'Brother' },
  { name: { en: 'Sister', ar: 'الأخت' }, id: 'Sister' },
  { name: { en: 'Paternal Uncle', ar: 'العم' }, id: 'Paternal Uncle' },
  { name: { en: 'Paternal Aunt', ar: 'العمة' }, id: 'Paternal Aunt' },
  { name: { en: 'Maternal Uncle', ar: 'الخال' }, id: 'Maternal Uncle' },
  { name: { en: 'Maternal Aunt', ar: 'الخالة' }, id: 'Maternal Aunt' },
  { name: { en: 'Guardian', ar: 'الوصي' }, id: 'Guardian' }
];

export const TransportationTime = [
  { name: { en: 'Morning Shift', ar: 'فترة صباحية' }, id: 'Morning Shift' },
  { name: { en: 'Evening Shift', ar: 'فترة مسائية' }, id: 'Evening Shift' }
];

export const MeansOfTransportation = [
  { name: { en: 'School Bus', ar: 'حافلة مدرسية' }, id: 'School Bus' },
  {
    name: {
      en: 'Transport Authority - Ajman Government',
      ar: 'هيئة النقل - حكومة عجمان'
    },
    id: 'Transport Authority - Ajman Government'
  },
  { name: { en: 'Private Car', ar: 'سيارة خاصة' }, id: 'Private Car' },
  { name: { en: 'By Parant', ar: 'عن طريق ولي الأمر' }, id: 'By Parant' }
];

export const BusRoute = [
  { name: { en: 'One Way', ar: 'إتجاه واحد' }, id: 'One Way' },
  { name: { en: 'Two Ways', ar: 'إتجاهين' }, id: 'Two Ways' }
];

export const StudentBlockStatuses = [
  { name: { en: 'Blocked', ar: 'محظور' }, id: 1 },
  { name: { en: 'Not Blocked', ar: 'غير محظور' }, id: 2 }
];

export const StudentBlockReasons = [
  { name: { en: 'Fees Due', ar: 'رسوم مستحقة' }, id: 'Fees Due' },
  {
    name: {
      en: 'Not completing the registration for the national service',
      ar: 'عدم الانتهاء من التسجيل في الخدمة الوطنية'
    },
    id: 'Not completing the registration for the national service'
  },
  { name: { en: 'Other', ar: 'أخرى' }, id: 'Other' }
];

export const Religiones_newStudent = [
  { name: { en: 'Muslim', ar: 'مسلم' }, id: 'muslim' },
  { name: { en: 'Non-Muslim', ar: 'غير مسلم' }, id: 'Non-Muslim' }
];

export const StudentDowngradeReson = [
  { name: { en: "Parent's wish", ar: 'رغبة ولي الأمر' }, id: 'Parent wish' },
  { name: { en: 'Others', ar: 'اخرى' }, id: 'Others' }
];

export const DegreeState = [
  { name: { en: 'Degree not completed', ar: 'لم تكتمل درجاته' }, id: 'DegreeNotCompleted' },
  { name: { en: 'Pass', ar: 'ناجح' }, id: 'pass' },
  { name: { en: 'Fail', ar: 'راسب' }, id: 'fail' }
];

export const IssueDoc_Transfer = [
  {
    name: { en: 'Inside the country', ar: 'داخل الدولة' },
    id: 'InsideTheCountry'
  },
  {
    name: { en: 'Outside the country', ar: 'خارج الدولة' },
    id: 'OutsideTheCountry'
  }
];

export const IssueDoc_Degree = [
  { name: { en: 'All subjects', ar: 'كل المواد' }, id: 'AllSubjects' },
  {
    name: { en: 'Ministerial subjects', ar: 'المواد الوزارية' },
    id: 'MinisterialSubjects'
  },
  {
    name: { en: 'Curriculum subjects', ar: 'مواد المنهاج' },
    id: 'CurriculumSubjects'
  }
];
